import { all } from 'redux-saga/effects';
import auth from './auth/sagas';
import common from './common/sagas';
import contactDPO from './contactDPO/sagas';
import CriacaoDosAssuntosDeContato from './CriacaoDosAssuntosDeContato/sagas';
import document from './document/sagas';
import ExibirHistoricoDeManutencaoDasAtividades from './ExibirHistoricoDeManutencaoDasAtividades/sagas';
import language from './language/sagas';
import ListaAuditoria from './ListaAuditoria/sagas';
import ManterAtividadesTratamentoDados from './ManterAtividadesTratamentoDados/sagas';
import theme from './theme/sagas';
import VisualizarDadosDosTitulares from './VisualizarDadosDosTitulares/sagas';

export default function* rootSaga() {
  return yield all([
    auth,
    language,
    contactDPO,
    theme,
    ManterAtividadesTratamentoDados,
    ExibirHistoricoDeManutencaoDasAtividades,
    CriacaoDosAssuntosDeContato,
    ListaAuditoria,
    VisualizarDadosDosTitulares,
    document,
    common,
  ]);
}
